import { Experiment } from '@amplitude/experiment-js-client';

export default async function ({ env, store }) {
    const tld = window.location.host.split('.').pop();
    let experimentApiKey = env.amplitudeExperimentDeploymentKey[tld];

    if (env.environment === 'development') {
        experimentApiKey = 'client-FYaIBMY0UMvWplCSGDdxWtKYNI5gopeY';
    }

    if (!experimentApiKey) {
        store.$amplitudeExperiment = {
            shouldDisplayExperimentalVariant: async function () {
                return false;
            },
        };
        return;
    }

    // (1) Initialize the experiment client with Amplitude Analytics.
    const experiment = Experiment.initializeWithAmplitudeAnalytics(
        experimentApiKey,
        { debug: !env.isProduction }
    );

    // (3) Make the Amplitude experiment instance globally available.
    store.$amplitudeExperiment = experiment;

    store.$amplitudeExperiment.shouldDisplayExperimentalVariant = async function (prodFlagKey, qaFlagKey = prodFlagKey) {
        try {
            if (!experiment.isRunning) {
                await experiment.start();
            }
        } catch (error) {
            console.error('Error initializing the Amplitude Experiment client');
            store.app.$sentry.captureException(error);
            return false;
        }

        const amplitudeExperimentFlagKey = env.isProduction ? prodFlagKey : qaFlagKey;

        return experiment.variant(amplitudeExperimentFlagKey).value === 'variant';
    };
}
